module.exports = __webpack_public_path__ + "static/media/thumbtack.4aa42bd2.svg";